import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  const data = isSuccessResponse(response)

  return (
    data?.map((item: any, index: any) => {
      return {
        approvalStatus: item?.approvalStatus,
        approvalType: item?.approvalType,
        className: item?.className,
        id: item?.id,
        key: item?.key,
        type: item?.type,
        username: item?.username,
        data: {
          type: 'merchant',
          id: item?.object?.id?.toString() ?? '',
          merchantId: item?.object?.merchantId ?? '',
          entityId: item?.object?.entityId,
          txnType: item?.object?.txnType,
          instrumentType: item?.object?.instrumentType,
          reqType: item?.object?.reqType ?? '',
          meCode: item?.object?.meCode ?? '',
          pgSecurityId: item?.object?.pgSecurityId ?? '',
          secret: item?.object?.secret ?? '',
          chiper: item?.object?.chiper ?? '',
          mcfg1: item?.object?.mcfg1 ?? '',
          mcfg2: item?.object?.mcfg2 ?? '',
          mappingStatus: item?.object?.mappingStatus ? 'true' : 'false',
        },
      }
    }) ?? []
  )
}

const getMerchantPendingApprovals = (elevated: boolean, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.merchantMappingPendingApprovals),
    method: 'GET',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {
      elevated,
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { getMerchantPendingApprovals }
